"use client";
import { useEffect, useState } from "react";

export default function ReadingProgress() {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      const el = document.querySelector("main");
      if (!el) return;
      const total = el.scrollHeight - window.innerHeight;
      const current = window.scrollY;
      const pct = Math.max(0, Math.min(1, current / total));
      setProgress(pct);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <div aria-hidden className="fixed left-0 right-0 top-0 z-40 h-1 bg-neutral-200">
      <div className="h-full" style={{ width: `${progress * 100}%`, background: "linear-gradient(90deg, var(--brand), #5c00c2)" }} />
    </div>
  );
}
